<div class="container-fluid">
    <div class="row">
        <div class="col-12 p-0">
            <div class="card-save">
                <div>
                    <div class="col-sm-12 text-center">
                        <div>
                            <h3>INVOICEX</h3>
                        </div>
                        <div>
                            Cảm ơn bạn đã ghé thăm dịch vụ của chúng tôi.
                        </div>
                        <div>
                            Bạn đã nhận được lời mời hợp tác đến từ <b>{{connectHistory.company?.company_name}}</b>.
                        </div>
                        <div class="cooperation_expired" v-if="!expiredToken" style="margin-top: 50px">
                            Xin lỗi quý khách ! Lời mời hợp tác đã hết hạn.
                        </div>
                        <div class="redirect_register" v-if="expiredToken && parseInt(connectHistory.status) === AppConstant.PARTNER_STATUS_INVITE && !isRegister" style="margin-top: 50px">
                            <div>
                                Vui lòng đăng ký tài khoản để tiếp tục quá trình hợp tác.
                            </div>
                            <div class="col-sm-12 d-flex justify-content-center">
                                <div style="width: 160px;margin-top: 20px;">
                                    <ButtonAddComponent :width="'200px'" :label="labelRegister" @click="registerAccount"></ButtonAddComponent>
                                </div>
                            </div>
                        </div>
                        <div class="redirect_confirm" v-if="expiredToken && parseInt(connectHistory.status) === AppConstant.PARTNER_STATUS_INVITE && isRegister" style="margin-top: 50px">
                            <div>
                                Vui lòng xác nhận để tiếp tục quá trình hợp tác.
                            </div>
                            <div class="col-sm-12 d-flex justify-content-center">
                                <div style="width: 160px;margin-top: 20px;">
                                    <ButtonAddComponent :width="'200px'" :label="labelConfirm" @click="confirmCooperate"></ButtonAddComponent>
                                </div>
                            </div>
                        </div>
                        <div class="confirm_cooperate" v-if="parseInt(connectHistory.status) === AppConstant.PARTNER_STATUS_REFUSE">
                            <div>
                                Vui lòng xác nhận để tiếp tục quá trình hợp tác được diễn ra.
                            </div>
                            <div class="col-sm-12 d-flex justify-content-center">
                                <div style="width: 120px;margin-top: 50px;">
                                    <ButtonAddComponent :width="'200px'" :label="labelRegister" @click="registerAccount"></ButtonAddComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
